import { ChartData } from './types';

export const PREVIOUS_VALUE_COLOR = '#4F96EB';
export const NEXT_VALUE_COLOR = '#C2D768';
export const PERCENTAGE_UP_COLOR = '#59A530';
export const PERCENTAGE_DOWN_COLOR = '#CD5024';

export const INITIAL_CHART_DATA: ChartData = {
    categories: [],
    series: [
        { name: 'Previous', data: [] },
        { name: 'Next', data: [] },
    ],
};
